module.exports = {
  title: '设置客户公海库',
  route: {
    path: '/user-manage',
    children: {
      path: 'en-user-highseas-from',
    },
  },
};
